/* ============
 * Bill payment Transformer
 * ============
 *
 * The transformer for the Bill.
 */

import Transformer from './transformer';

export default class BillPaymentTransformer extends Transformer {

  static fetch(billPayment) {
    return {
      billId: billPayment.bill_id,
      paymentMethod: billPayment.payment_method,
      amountPaid: billPayment.amount_paid,
      paymentDate: billPayment.payment_date,
      reference: billPayment.reference,
      internalNote: billPayment.internal_note,
    };
  }

  static send(billPayment) {
    return {
      id: billPayment.id,
      is_fully_paid: billPayment.isFullyPaid,
      payment_method: billPayment.paymentMethod,
      amount_paid: billPayment.amountPaid,
      payment_date: billPayment.paymentDate,
      reference: billPayment.reference,
      internal_note: billPayment.internalNote,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/billPayment.js